var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.875 2.5C4.45875 2.5 2.5 4.45875 2.5 6.875C2.5 9.29125 4.45875 11.25 6.875 11.25C9.29125 11.25 11.25 9.29125 11.25 6.875C11.25 4.45875 9.29125 2.5 6.875 2.5ZM1.25 6.875C1.25 3.7684 3.7684 1.25 6.875 1.25C9.9816 1.25 12.5 3.7684 12.5 6.875C12.5 9.9816 9.9816 12.5 6.875 12.5C3.7684 12.5 1.25 9.9816 1.25 6.875Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96431 9.96431C10.2084 9.72023 10.6041 9.72023 10.8482 9.96431L13.5669 12.6831C13.811 12.9271 13.811 13.3229 13.5669 13.5669C13.3229 13.811 12.9271 13.811 12.6831 13.5669L9.96431 10.8482C9.72023 10.6041 9.72023 10.2084 9.96431 9.96431Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6fd8a35ed16009428a43ba28835b7ac7.svg";
export { ForwardRef as ReactComponent };